import request from './request';
export const fetchUserCampaigns = () =>
  request({
    method: 'GET',
    url: '/clients/campaigns',
    protectedRoute: true,
    newApi: true
  });
